import haversine from 'haversine';
type ProductInfo = {
  _id: string;
  name: string;
  group: string;
  volume: number;
  price: number;
  image: string;
};

type Sale = {
  products: { product: ProductInfo; cases: number }[];
};

type GroupedProduct = {
  productId: string;
  name: string;
  group: string;
  volume: number;
  price: number;
  image: string;
  totalCases: number;
};

function groupAllProducts(sales: Sale[]): GroupedProduct[] {
  const productMap: Record<string, GroupedProduct> = {};

  for (const sale of sales) {
    for (const item of sale.products) {
      const prod = item.product;
      const id = prod._id;

      if (!productMap[id]) {
        productMap[id] = {
          productId: id,
          name: prod.name,
          group: prod.group,
          volume: prod.volume,
          price: prod.price,
          image: prod.image,
          totalCases: 0,
        };
      }

      productMap[id].totalCases += item.cases;
    }
  }
  return Object.values(productMap);
}


export const totalCases=(skus:any[])=>{
    if(!skus) return 0;
    return skus?.reduce((total, sku) => total + parseInt(sku?.cases||0), 0);
}

export const totalWaterCases=(skus:any[])=>{
    if(!skus) return 0;
    return groupAllProducts(skus)?.filter((p)=>p?.group==='water').reduce((total, sku) => total + sku?.totalCases||0, 0);
}

export const totalJuiceCases=(skus:any[])=>{
    if(!skus) return 0;
    return groupAllProducts(skus)?.filter((p)=>p?.group!=='water').reduce((total, sku) => total + sku?.totalCases||0, 0);
}

export const totalPiece=(skus:any[])=>{
    return skus.reduce((total, sku) => total + parseInt(sku?.piece||0), 0);
}

export function totalLocationDistance(coordinates: { latitude: number, longitude: number }[]): number {
  const coords = coordinates;
  let totalDistance = 0;
  for (let i = 1; i < coords.length; i++) {
    const prev = coords[i - 1];
    const curr = coords[i];
    totalDistance += haversine(prev, curr,{unit:'km'});
  }
  return parseFloat(totalDistance.toFixed(2));
}